import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { PublicAuthRoutes } from '@repo/shared/api-routes/public/auth'
import { AxiosInstance } from 'axios'

import { IAuthApi } from '@/spi/api/auth'

export const buildAuthApi = (axios: AxiosInstance): IAuthApi => ({
  login: async (payload) => {
    const response = await tryCatch(async () =>
      axios.post<typeof PublicAuthRoutes.login.response>(PublicAuthRoutes.login.getPath(), {
        payload,
      } satisfies typeof PublicAuthRoutes.login.request),
    )
    if (hasError(response)) return handleError(response)
    return { accessToken: response.data.access_token }
  },

  signup: async (payload) => {
    const response = await tryCatch(async () =>
      axios.post<typeof PublicAuthRoutes.signup.response>(PublicAuthRoutes.signup.getPath(), {
        payload,
      } satisfies typeof PublicAuthRoutes.signup.request),
    )
    if (hasError(response)) return handleError(response)
    return response.data
  },
})
